
import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import {getModule} from 'vuex-module-decorators';
import {ShopModule, TradeInModule, store} from '@returns-centre/store';
import tickIcon from "@returns-centre/resources/tick-minor.svg";
import cancelIcon from "@returns-centre/resources/CancelSmallMinor.svg";
import deleteIcon from '@returns-centre/resources/DeleteMinor.svg';
import editIcon from '@returns-centre/resources/EditMinor.svg';

@Component
export default class TradeInSummaryModal extends Vue {
    shopModule = getModule(ShopModule, store);
    tradeInModule = getModule(TradeInModule, store);
    categories = this.tradeInModule.getCategories;

    tickIcon = tickIcon;
    cancelIcon = cancelIcon;
    deleteIcon = deleteIcon;
    editIcon = editIcon;

    selectedTradeInProductRecordIndex: TradeInProductRecord|number|null = null;
    selectedOrderLineItemIndex: string|null = null;
    selectedTradeInProductRecord: TradeInProductRecord|null = null;

    deleteOrderLineItem(deleteOrderLineItemIndex: string) {
       this.tradeInModule.removeTradeInOrderItem(deleteOrderLineItemIndex);
       this.selectedOrderLineItemIndex = null;
       this.tradeInModule.createTradeInOrderItems();
    }

    async editTradeInProductRecord(tradeInProductRecord: TradeInProductRecord) {
        this.selectedTradeInProductRecord = tradeInProductRecord;
        this.$emit('tradeInProductRecordSelected', tradeInProductRecord)
    }

    async deleteTradeInProductRecord(tradeInProductRecord: TradeInProductRecord) {
        this.selectedTradeInProductRecord = null;
        await this.tradeInModule.removeTradeInProduct(tradeInProductRecord);
        this.selectedTradeInProductRecordIndex = null;
    }

    getProductImage(url?: string | null): string {
        if (url) return url;

        return this.shopModule.shop?.product_image as string;
    }
}
